import {
    ListItemBlockStyled,
    ListItemCountStyled,
    ListItemImageStyled,
    ListItemNameStyled,
    ListItemNameWrapperStyled,
} from './ListItem.style';
import Image from 'components/Basic/Image/Image';
import { FriendlyPagesTypesKeys } from 'types/friendlyUrl';
import { ListedItemPropType } from 'types/simpleNavigation';

type ListItemProps = {
    listedItem: ListedItemPropType;
    type: FriendlyPagesTypesKeys;
};

const ListItem: FC<ListItemProps> = ({ listedItem, type }) => {
    const testIdentifier = 'blocks-simplenavigation-listitem';

    return (
        <ListItemBlockStyled data-testid={testIdentifier} type={type} href={listedItem.link ?? listedItem.slug}>
            <>
                {'image' in listedItem && (
                    <ListItemImageStyled>
                        {listedItem.image !== null ? (
                            <Image src={listedItem.image} alt={listedItem.name} width="48" height="64" />
                        ) : (
                            <Image src="/images/noimage-arrow.png" alt={listedItem.name} width="48" height="64" />
                        )}
                    </ListItemImageStyled>
                )}
                <ListItemNameWrapperStyled>
                    <ListItemNameStyled>{listedItem.name}</ListItemNameStyled>
                    {'totalCount' in listedItem && listedItem.totalCount !== undefined && (
                        <ListItemCountStyled>({listedItem.totalCount})</ListItemCountStyled>
                    )}
                </ListItemNameWrapperStyled>
            </>
        </ListItemBlockStyled>
    );
};

export default ListItem;
